"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMfa = fetchMfa;
exports.updateMfa = updateMfa;
exports.sendSMS = sendSMS;
exports.sendTOTP = sendTOTP;
exports.confirm = confirm;
exports.fetchRecovery = fetchRecovery;
exports.validateRecovery = validateRecovery;
exports.deleteRecovery = deleteRecovery;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _utils2 = require("../utils");

var endpoints = {
  fetch: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/auth_settings");
    }
  },
  update: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/na/auth_settings");
    }
  },
  sendSMS: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/na/mfa/send");
    }
  },
  sendTOTP: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/na/mfa/totp");
    }
  },
  confirm: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/na/mfa/confirm");
    }
  },
  fetchRecovery: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/na/recovery");
    }
  },
  validateRecovery: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/na/recovery");
    }
  },
  deleteRecovery: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/na/recovery");
    }
  }
};
exports.endpoints = endpoints;

/**
 * Get the user’s authentication settings.
 *
 * @public
 * @param {Auth} auth - User authentication info
 * @returns {Promise<UploadResponse>}
 */
function fetchMfa(_x) {
  return _fetchMfa.apply(this, arguments);
}
/**
 * Change the user’s authentication settings. MFA will not enabled until the confirmation api is successfully called
 *
 * @public
 * @param {boolean} enable2FactorAuthentication - Toggle MFA login on/off
 * @param {string} password - Password to authenticate
 * @param {Auth} auth - User authentication info
 * @returns {Promise<any>}
 */


function _fetchMfa() {
  _fetchMfa = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(auth) {
    var _endpoints$fetch, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _endpoints$fetch = endpoints.fetch, method = _endpoints$fetch.method, url = _endpoints$fetch.url;
            _context.next = 3;
            return (0, _requests.request)(url(), method, (0, _utils.withAuth)(auth)(_utils.defaultOptionals));

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchMfa.apply(this, arguments);
}

function updateMfa(_x2, _x3) {
  return _updateMfa.apply(this, arguments);
}
/**
 * Sends an MFA code to the user. If MFA number is already confirmed, phoneNumber parameter is ignored
 *
 * @public
 * @param {string} mfaToken - The JWT MFA token
 * @param {?string} phoneNumber - mobile number to receive MFA SMS, if login resend not need to pass
 * @param {Auth} {auth} - User authentication info
 * @returns {Promise<any>}
 */


function _updateMfa() {
  _updateMfa = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref, extraAuth) {
    var enable2FactorAuthentication, method, optionals, _endpoints$update, updateMethod, url;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enable2FactorAuthentication = _ref.enable2FactorAuthentication, method = _ref.method;
            optionals = (0, _functools.compose)((0, _utils.withExtraAuth)(extraAuth), (0, _requests.withBody)({
              enable2FactorAuthentication: enable2FactorAuthentication,
              method: method
            }))(_utils.defaultOptionals);
            _endpoints$update = endpoints.update, updateMethod = _endpoints$update.method, url = _endpoints$update.url;
            _context2.next = 5;
            return (0, _requests.request)(url(), updateMethod, optionals);

          case 5:
            return _context2.abrupt("return", _context2.sent);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _updateMfa.apply(this, arguments);
}

function sendSMS(_x4, _x5) {
  return _sendSMS.apply(this, arguments);
}
/**
 * Generates a TOTP secret for the user and returns the QR code
 *
 * @public
 * @param {string} mfaToken - The JWT MFA token
 * @returns {Promise<any>}
 */


function _sendSMS() {
  _sendSMS = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref2, extraAuth) {
    var phoneNumber, countryCode, optionals, _endpoints$sendSMS, method, url;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            phoneNumber = _ref2.phoneNumber, countryCode = _ref2.countryCode;
            optionals = (0, _functools.compose)((0, _utils.withExtraAuth)(extraAuth), (0, _requests.withBody)(countryCode ? {
              phoneNumber: phoneNumber,
              countryCode: countryCode
            } : {
              phoneNumber: phoneNumber
            }))(_utils.defaultOptionals);
            _endpoints$sendSMS = endpoints.sendSMS, method = _endpoints$sendSMS.method, url = _endpoints$sendSMS.url;
            _context3.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            return _context3.abrupt("return", _context3.sent);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _sendSMS.apply(this, arguments);
}

function sendTOTP(_x6) {
  return _sendTOTP.apply(this, arguments);
}
/**
 * Confirms that the MFA mobile number is correct and finally enables MFA for login.
 *
 * @public
 * @param {string} mfaCode -  The MFA confirmation code
 * @param {string} mfaToken -The JWT MFA token
 * @returns {Promise<any>}
 */


function _sendTOTP() {
  _sendTOTP = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(extraAuth) {
    var optionals, _endpoints$sendTOTP, method, url;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withExtraAuth)(extraAuth))(_utils.defaultOptionals);
            _endpoints$sendTOTP = endpoints.sendTOTP, method = _endpoints$sendTOTP.method, url = _endpoints$sendTOTP.url;
            _context4.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            return _context4.abrupt("return", _context4.sent);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _sendTOTP.apply(this, arguments);
}

function confirm(_x7, _x8) {
  return _confirm.apply(this, arguments);
}
/**
 * Generate single use recovery codes for login when all else fails
 *
 * @public
 * @param {string} mfaAuth -The JWT MFA token
 * @returns {Promise<any>}
 */


function _confirm() {
  _confirm = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(mfaCode, extraAuth) {
    var optionals, _endpoints$confirm, method, url;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _requests.withHeaders)({
              'x-Auth-MFACode': mfaCode
            }), (0, _utils.withExtraAuth)(extraAuth))(_utils.defaultOptionals);
            _endpoints$confirm = endpoints.confirm, method = _endpoints$confirm.method, url = _endpoints$confirm.url;
            _context5.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            return _context5.abrupt("return", _context5.sent);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _confirm.apply(this, arguments);
}

function fetchRecovery(_x9) {
  return _fetchRecovery.apply(this, arguments);
}
/**
 * Log in with a recovery code. If successful, refresh token is set in cookies like in standard login
 *
 * @public
 * @param {string} emailAddress - The email address to login
 * @param {string} password - The email address to login
 * @param {string} recoveryCode - One of the recovery codes generated earlier
 * @returns {Promise<any>}
 */


function _fetchRecovery() {
  _fetchRecovery = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(extraAuth) {
    var optionals, _endpoints$fetchRecov, method, url;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withExtraAuth)(extraAuth))(_utils.defaultOptionals);
            _endpoints$fetchRecov = endpoints.fetchRecovery, method = _endpoints$fetchRecov.method, url = _endpoints$fetchRecov.url;
            _context6.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            return _context6.abrupt("return", _context6.sent);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchRecovery.apply(this, arguments);
}

function validateRecovery(_x10, _x11, _x12) {
  return _validateRecovery.apply(this, arguments);
}
/**
 * Delete active recovery codes
 *
 * @public
 * @param {string} extraAuth -The JWT MFA token
 * @returns {Promise<any>}
 */


function _validateRecovery() {
  _validateRecovery = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(emailAddress, password, recoveryCode) {
    var optionals, _endpoints$validateRe, method, url;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _requests.withHeaders)({
              'x-Auth-User': emailAddress,
              'x-Auth-Password': password,
              'x-Auth-RecoveryCode': recoveryCode
            }))(_utils.defaultOptionals);
            _endpoints$validateRe = endpoints.validateRecovery, method = _endpoints$validateRe.method, url = _endpoints$validateRe.url;
            _context7.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            return _context7.abrupt("return", _context7.sent);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _validateRecovery.apply(this, arguments);
}

function deleteRecovery(_x13) {
  return _deleteRecovery.apply(this, arguments);
}

function _deleteRecovery() {
  _deleteRecovery = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(extraAuth) {
    var optionals, _endpoints$deleteReco, method, url;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withExtraAuth)(extraAuth))(_utils.defaultOptionals);
            _endpoints$deleteReco = endpoints.deleteRecovery, method = _endpoints$deleteReco.method, url = _endpoints$deleteReco.url;
            _context8.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            return _context8.abrupt("return", _context8.sent);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _deleteRecovery.apply(this, arguments);
}
//# sourceMappingURL=mfa.js.map